'use es6';

import { useMemo } from 'react';
import styled, { css } from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Image } from 'foundations-components/transitional/components/Image';
import DragHandle from 'FormsCommonComponents/editor/draggable/DragHandle';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Wrapper = styled.div.withConfig({
  displayName: "FieldDraggableBox__Wrapper"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return css(["width:130px;height:130px;border:1px solid ", ";border-radius:4px;box-shadow:3px 3px 9px rgba(", ",0.5);background:", ";&[disabled]{opacity:0.5;background:", ";box-shadow:0 !important;border:0;&:hover{cursor:not-allowed;}}&:hover:not([disabled]){border:1px solid rgba(", ",0.7);border-color:rgba(116,218,230,1);cursor:grab !important;box-shadow:0 0 8px 1px rgba(91,212,226,0.6);}"], theme.color['fill-tertiary-pressed'], theme.color['fill-tertiary-pressed'], theme.color['fill-surface-default'], theme.color['fill-primary-disabled'], theme.color['fill-info-default']);
});
const IconWrapper = styled.div.withConfig({
  displayName: "FieldDraggableBox__IconWrapper"
})(["width:66px;height:66px;display:flex;justify-content:center;align-items:center;"]);
const FieldDraggableBox = ({
  fieldType,
  disabled,
  fieldTypesWithIcon,
  fieldImageMapping,
  FieldIconMapping
}) => {
  const icon = useMemo(() => {
    const isIcon = fieldTypesWithIcon[fieldType];
    const fieldIconImage = fieldImageMapping[fieldType];
    const FieldIconSource = FieldIconMapping[fieldType];
    return isIcon ? /*#__PURE__*/_jsx(IconWrapper, {
      children: /*#__PURE__*/_jsx(FieldIconSource, {
        size: '800'
      })
    }) : /*#__PURE__*/_jsx(Image, {
      src: fieldIconImage,
      width: 66,
      height: 42
    });
  }, [fieldType, fieldTypesWithIcon, FieldIconMapping, fieldImageMapping]);
  return /*#__PURE__*/_jsx(Wrapper, {
    disabled: disabled,
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "between",
      children: [/*#__PURE__*/_jsx(DragHandle, {}), icon, /*#__PURE__*/_jsx(Text, {
        as: "small",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `fieldDraggableBox.createNewFieldSection.fieldTypes.${fieldType}`
        })
      })]
    })
  });
};
export default FieldDraggableBox;